import styled from 'styled-components';
import { colors } from '../styles/variables';

const InventoryListView = styled.div`
  max-height: 200px;
  padding: 8px;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  &::-webkit-scrollbar {
    width: 1px;
  }
  &::-webkit-scrollbar-track-piece {
    background: ${colors.gray300};
  }
  &::-webkit-scrollbar-thumb {
    background: ${colors.gray600};
  }
`;

export default InventoryListView;
